import { render, staticRenderFns } from "./HraSummaryRisk.vue?vue&type=template&id=fb558498"
import script from "./HraSummaryRisk.vue?vue&type=script&lang=js"
export * from "./HraSummaryRisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports